/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCalculationCycleResponse } from './GetCalculationCycleResponse';
import {
    GetCalculationCycleResponseFromJSON,
    GetCalculationCycleResponseFromJSONTyped,
    GetCalculationCycleResponseToJSON,
    GetCalculationCycleResponseToJSONTyped,
} from './GetCalculationCycleResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetCalculationCycleResponse
 */
export interface PaginatedResultOfGetCalculationCycleResponse {
    /**
     * 
     * @type {Array<GetCalculationCycleResponse>}
     * @memberof PaginatedResultOfGetCalculationCycleResponse
     */
    items?: Array<GetCalculationCycleResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetCalculationCycleResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetCalculationCycleResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetCalculationCycleResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetCalculationCycleResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetCalculationCycleResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetCalculationCycleResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetCalculationCycleResponse interface.
 */
export function instanceOfPaginatedResultOfGetCalculationCycleResponse(value: object): value is PaginatedResultOfGetCalculationCycleResponse {
    return true;
}

export function PaginatedResultOfGetCalculationCycleResponseFromJSON(json: any): PaginatedResultOfGetCalculationCycleResponse {
    return PaginatedResultOfGetCalculationCycleResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetCalculationCycleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetCalculationCycleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetCalculationCycleResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetCalculationCycleResponseToJSON(json: any): PaginatedResultOfGetCalculationCycleResponse {
    return PaginatedResultOfGetCalculationCycleResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetCalculationCycleResponseToJSONTyped(value?: PaginatedResultOfGetCalculationCycleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetCalculationCycleResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

